import { render, staticRenderFns } from "./storagelist.vue?vue&type=template&id=71c6d77f&scoped=true&"
import script from "./storagelist.vue?vue&type=script&lang=js&"
export * from "./storagelist.vue?vue&type=script&lang=js&"
import style0 from "./storagelist.vue?vue&type=style&index=0&id=71c6d77f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c6d77f",
  null
  
)

export default component.exports